import { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from './competencyCard.module.scss';

const cx = classNames.bind(styles);

type CARD_TYPE = 'green' | 'gray';
type ICON_TYPE = 'profile' | 'company' | 'job' | 'guide';

interface CompetencyCard {
  title?: ReactElement | string;
  children?: ReactElement | string;
  cardType?: CARD_TYPE;
  iconType?: ICON_TYPE;
}

const CompetencyCard = ({ title, children, cardType, iconType }: CompetencyCard) => {
  return (
    <div className={cx('cardArea')}>
      <div className={cx('cardWrap')}>
        <div className={cx('titleArea', cardType, iconType)}>
          <strong className={cx('title')}>{title}</strong>
        </div>
        <div className={cx('contentsArea')}>{children}</div>
      </div>
    </div>
  );
};

export default CompetencyCard;
